import { PropsWithChildren } from 'react';

import { Typography, Stack, tokens } from '@cast/design-system';

export const HighlightedItem = ({
  label,
  children,
}: PropsWithChildren<{ label: string }>) => (
  <Stack
    borderLeft={tokens.theme.border.structural.neutral}
    gap={4}
    pl={8}
    mt={4}
  >
    <Typography variant="L10R" color={tokens.theme.fg.structural.secondary}>
      {label}
    </Typography>
    <Stack direction="row" alignItems="center" gap={8}>
      {children}
    </Stack>
  </Stack>
);
